export default function MainContainer({ children }) {
    return (
        <main className="flex flex-col min-h-screen w-screen bg-white px-4 sm:px-8 md:px-16 lg:px-28 pt-16 lg:pt-20">
            {/*  pt-16 (64px) default, pt-20 (80px) md and up */}
            <div className="flex-grow xl:max-w-7xl xl:mx-auto">{children}</div>
        </main>
    );
}
